
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'data-privacy-request-ui',
  currentProjectVersion: 'static-1.5446',
  depVersions: {
  "data-privacy-request-ui": "static-1.5446",
  "data-fetching-client": "static-1.9593",
  "head-dlb": "static-1.4938",
  "history": "static-4.47",
  "hs-test-utils": "static-1.7930",
  "hub-http-shared-msw-handlers": "static-1.9774",
  "hubspot-dlb": "static-2.1832",
  "HubStyleTokens": "static-2.11377",
  "I18n": "static-7.1605",
  "jasmine-runner": "static-1.6385",
  "privacy-center-public-service-types": "static-1.4709",
  "quartz": "static-1.6895",
  "react-dlb": "static-1.77",
  "react-router-dom": "static-5.26",
  "ui-components-test-utils": "static-1.5515",
  "UIComponents": "static-3.8324",
  "webpack-env": "static-1.54",
  "apollo-stack-hubspot": "static-3.84",
  "foundations-assets": "static-1.4769",
  "foundations-components": "static-1.7767",
  "foundations-components-test-utils": "static-1.5250",
  "foundations-theming": "static-1.4332",
  "hub-http": "static-1.6139",
  "quartz-config": "static-1.673",
  "quartz-core": "static-1.6114",
  "quartz-routing": "static-1.325",
  "quick-fetch": "static-1.3851",
  "raven": "static-3.5829",
  "react": "static-7.184",
  "react-rhumb": "static-1.16577",
  "SharedI18nStrings": "static-1.182",
  "ui-addon-i18n": "static-1.11067",
  "usage-tracker": "static-1.7254",
  "usage-tracker-anonymous": "static-1.5671",
  "usage-tracker-core": "static-1.7104",
  "enviro": "static-4.428",
  "hs-promise-rejection-tracking": "static-1.5489",
  "PortalIdParser": "static-2.388",
  "raven-hubspot": "static-1.6136",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "hubspot-url-utils": "static-1.4049",
  "immutable": "static-2.77",
  "metrics-js": "static-1.9542",
  "react-redux": "static-7.70",
  "redux": "static-4.16",
  "styled-components": "static-2.88",
  "bend-plugin-trellis-migration": "static-1.3335",
  "moment": "static-3.26",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.3172",
  "quartz-webpack": "static-1.3119",
  "fast-json-stable-stringify": "static-1.4",
  "graphql": "static-1.80",
  "HeadJS": "static-2.736",
  "framer-motion": "static-1.70",
  "hs-test-utils-bend-plugin": "static-1.3041",
  "msw": "static-1.39",
  "testing-library": "static-1.150",
  "ts-schema": "static-1.4012",
  "i18n-data": "static-1.219",
  "moment-timezone": "static-5.81",
  "react-utils": "static-2.5277",
  "StyleGuideUI": "static-3.485",
  "jasmine": "static-4.4241",
  "rpc-client-utils": "static-1.4562",
  "HubStyle": "static-2.11685",
  "ui-addon-draggable": "static-3.4687",
  "cssUtils": "static-1.772",
  "hs-story-utils": "static-1.9348",
  "icons": "static-2.639",
  "react-select-plus": "static-1.65",
  "react-virtualized": "static-2.97",
  "ui-images": "static-2.1132",
  "bend-plugin-foundations-components": "static-1.4036",
  "floating-ui": "static-1.54",
  "foundations-theming-specialty": "static-1.2048",
  "react-aria": "static-1.64",
  "tanstack-table": "static-1.53",
  "trellis-assets": "static-1.1580",
  "ui-fonts": "static-1.639",
  "foundations-components-legacy": "static-1.792",
  "bend-plugin-foundations-theming": "static-1.2815",
  "foundations-theming-base": "static-1.3317",
  "stylex": "static-1.30",
  "hs-locale-management": "static-1.18",
  "dispatcher": "static-1.134",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.821",
  "hubspotter-http": "static-1.4586",
  "mobile-manifest-mixins": "static-1.510",
  "module-federation": "static-1.21",
  "quartz-auth": "static-1.570",
  "quartz-head": "static-1.560",
  "quartz-i18n": "static-1.570",
  "quartz-test": "static-1.570",
  "quartz-tracking": "static-1.274",
  "usage-tracker-container": "static-1.7244",
  "csstype": "static-1.50",
  "react-input-autosize": "static-2.17",
  "bender-build-tools": "static-1.3093",
  "chirp-fetch": "static-1.1800",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "react-flip-move": "static-1.68",
  "sassPrefix": "static-1.154",
  "hubspotter-http-shared-msw-handlers": "static-1.9772",
  "usage-tracker-session-replay": "static-1.4940",
  "amplitude-session-replay-browser": "static-1.58"
},
  depPathPrefixes: {
  "data-privacy-request-ui": "/data-privacy-request-ui/static-1.5446",
  "data-fetching-client": "/data-fetching-client/static-1.9593",
  "head-dlb": "/head-dlb/static-1.4938",
  "history": "/history/static-4.47",
  "hs-test-utils": "/hs-test-utils/static-1.7930",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9774",
  "hubspot-dlb": "/hubspot-dlb/static-2.1832",
  "HubStyleTokens": "/HubStyleTokens/static-2.11377",
  "I18n": "/I18n/static-7.1605",
  "jasmine-runner": "/jasmine-runner/static-1.6385",
  "privacy-center-public-service-types": "/privacy-center-public-service-types/static-1.4709",
  "quartz": "/quartz/static-1.6895",
  "react-dlb": "/react-dlb/static-1.77",
  "react-router-dom": "/react-router-dom/static-5.26",
  "ui-components-test-utils": "/ui-components-test-utils/static-1.5515",
  "UIComponents": "/UIComponents/static-3.8324",
  "webpack-env": "/webpack-env/static-1.54",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.84",
  "foundations-assets": "/foundations-assets/static-1.4769",
  "foundations-components": "/foundations-components/static-1.7767",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5250",
  "foundations-theming": "/foundations-theming/static-1.4332",
  "hub-http": "/hub-http/static-1.6139",
  "quartz-config": "/quartz-config/static-1.673",
  "quartz-core": "/quartz-core/static-1.6114",
  "quartz-routing": "/quartz-routing/static-1.325",
  "quick-fetch": "/quick-fetch/static-1.3851",
  "raven": "/raven/static-3.5829",
  "react": "/react/static-7.184",
  "react-rhumb": "/react-rhumb/static-1.16577",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11067",
  "usage-tracker": "/usage-tracker/static-1.7254",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.5671",
  "usage-tracker-core": "/usage-tracker-core/static-1.7104",
  "enviro": "/enviro/static-4.428",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5489",
  "PortalIdParser": "/PortalIdParser/static-2.388",
  "raven-hubspot": "/raven-hubspot/static-1.6136",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4049",
  "immutable": "/immutable/static-2.77",
  "metrics-js": "/metrics-js/static-1.9542",
  "react-redux": "/react-redux/static-7.70",
  "redux": "/redux/static-4.16",
  "styled-components": "/styled-components/static-2.88",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3335",
  "moment": "/moment/static-3.26",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3172",
  "quartz-webpack": "/quartz-webpack/static-1.3119",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "graphql": "/graphql/static-1.80",
  "HeadJS": "/HeadJS/static-2.736",
  "framer-motion": "/framer-motion/static-1.70",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3041",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.150",
  "ts-schema": "/ts-schema/static-1.4012",
  "i18n-data": "/i18n-data/static-1.219",
  "moment-timezone": "/moment-timezone/static-5.81",
  "react-utils": "/react-utils/static-2.5277",
  "StyleGuideUI": "/StyleGuideUI/static-3.485",
  "jasmine": "/jasmine/static-4.4241",
  "rpc-client-utils": "/rpc-client-utils/static-1.4562",
  "HubStyle": "/HubStyle/static-2.11685",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4687",
  "cssUtils": "/cssUtils/static-1.772",
  "hs-story-utils": "/hs-story-utils/static-1.9348",
  "icons": "/icons/static-2.639",
  "react-select-plus": "/react-select-plus/static-1.65",
  "react-virtualized": "/react-virtualized/static-2.97",
  "ui-images": "/ui-images/static-2.1132",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4036",
  "floating-ui": "/floating-ui/static-1.54",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2048",
  "react-aria": "/react-aria/static-1.64",
  "tanstack-table": "/tanstack-table/static-1.53",
  "trellis-assets": "/trellis-assets/static-1.1580",
  "ui-fonts": "/ui-fonts/static-1.639",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.792",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2815",
  "foundations-theming-base": "/foundations-theming-base/static-1.3317",
  "stylex": "/stylex/static-1.30",
  "hs-locale-management": "/hs-locale-management/static-1.18",
  "dispatcher": "/dispatcher/static-1.134",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.821",
  "hubspotter-http": "/hubspotter-http/static-1.4586",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.510",
  "module-federation": "/module-federation/static-1.21",
  "quartz-auth": "/quartz-auth/static-1.570",
  "quartz-head": "/quartz-head/static-1.560",
  "quartz-i18n": "/quartz-i18n/static-1.570",
  "quartz-test": "/quartz-test/static-1.570",
  "quartz-tracking": "/quartz-tracking/static-1.274",
  "usage-tracker-container": "/usage-tracker-container/static-1.7244",
  "csstype": "/csstype/static-1.50",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "bender-build-tools": "/bender-build-tools/static-1.3093",
  "chirp-fetch": "/chirp-fetch/static-1.1800",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "react-flip-move": "/react-flip-move/static-1.68",
  "sassPrefix": "/sassPrefix/static-1.154",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9772",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.4940",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.58"
}
};
